import { render, staticRenderFns } from "./stake-pair-calculator.vue?vue&type=template&id=42534aae&scoped=true&"
import script from "./stake-pair-calculator.vue?vue&type=script&lang=ts&"
export * from "./stake-pair-calculator.vue?vue&type=script&lang=ts&"
import style0 from "./stake-pair-calculator.vue?vue&type=style&index=0&id=42534aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42534aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VChip,VChipGroup,VIcon,VImg,VSheet,VTextField,VTooltip})
